import { RRule } from 'rrule';
import { recurRangeTypeEnum, recurTypeEnum, validWeekDays } from './enums';

//get ocurrence list
export const getRecurrence = (
  recurType,
  rangeType,
  startDate,
  endDate,
  count = 1,
  repeatEach = 1,
  byweekDay = [],
  byMonthDay = 0
) => {
  let rRule = {};

  //eval recurr type
  if (recurType === recurTypeEnum.DAILY) {
    rRule.freq = RRule.DAILY;
    rRule.interval = 1;
    rRule.dtstart = startDate;
    rRule.byweekday = validWeekDays;
  }
  if (recurType === recurTypeEnum.WEEKLY) {
    rRule.freq = RRule.WEEKLY;
    rRule.interval = repeatEach;
    rRule.byweekday = byweekDay;
  }
  if (recurType === recurTypeEnum.MONTHLY) {
    rRule.interval = repeatEach;
    rRule.freq = RRule.MONTHLY;
    rRule.bymonthday = byMonthDay;
    rRule.byweekday = validWeekDays;
  }

  //eval range type
  if (rangeType === recurRangeTypeEnum.DATE_FINALIZE) {
    rRule.until = endDate;
  } else {
    rRule.count = count;
  }

  return new RRule(rRule).all();
};
